import React from "react";

const SegLogo = ({
  src,
  alt = "Logo",
  className = "w-25 h-20 h-auto",
}) => {
  return (
    <div className="w-full flex justify-center items-center bg-sky-600 py-5">
      <img
        src={src}
        alt={alt}
        loading="eager"
        className={className}
      />
    </div>
  );
};

export default SegLogo;
